<template>
  <div
    v-if="isLoading || isError || !clickmap.length"
    class="cm-state-card__body"
    :class="{'cm-state-card__body--not-ok': isLoading || isError || !clickmap.length }"
  >
    <Spinner
      v-if="isLoading"
      position="relative"
    />
    <p
      v-else-if="isError"
      class="cm-state-card__body--error"
    >
      {{ $t(`campaign.statistics.errorWhileGettingData`) }}
    </p>
    <p
      v-else-if="!clickmap.length"
      class="cm-state-card__body--empty"
    >
      {{ $t(`campaign.statistics.notFound`) }}
    </p>
  </div>

  <div
    v-else
    class="click-map__main"
    @click="clickClickmap"
  >
    <div class="tabs-header__title-container">
      <h4 class="cm-title">
        {{ $t('campaign.forPeriod.numberClicks') }} {{ selectedPeriod }}
      </h4>
      <div>
        <spinner
          v-show="stateBtnClick"
          position="relative"
          class="spinner_small_clickMap"
          :size="25"
          :center="false"
        />
        <CustomButtonSelect
          :label="this.$t(`loyalty.controls.exportButton`)"
          iconButton="export2"
          :allow="!stateBtnClick"
          :options="selectOptions"
          :class="{'stateBtnClickStyles': !stateBtnClick}"
          class="spinner_styles"
          @current="fileExport"
        />
      </div>
    </div>

    <div class="click-map">
      <div
        v-if="clickmap && clickmap.length"
        class="click-map__wrapper"
      >
        <div
          v-if="showTemplateSelect && adapteredTemplates.length > 1"
          class="click-map__select"
        >
          {{ $t('campaign.form.selectDesiredSegmentName') }}
          <cm-select
            v-model="selectedTemplate"
            :options="adapteredTemplates"
          />
        </div>

        <div class="click-map__select">
          {{ $t('campaign.form.selectWhatDisplayTemplate') }}
          <cm-select
            v-model="selectedTableParams"
            :options="tableParamsOptions"
          />
        </div>

        <scale-number-clicks />

        <div
          class="click-map__template"
          v-html="template"
        />
      </div>

      <div
        id="cm-table"
        class="click-map__table"
      >
        <TablePart
          v-if="isTable"
          :value="statsTableValue"
        />
        <div v-else>
          <TablePart :value="filteredValues" />
          <Button
            skin="primary"
            :padding="30"
            @click.native="isTable = !isTable"
          >
            {{ $t('campaign.form.cancelFiltering') }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScaleNumberClicks from "./ScaleNumberClicks.vue";
import TablePart from "./TablePart.vue";
import Button from "@/manzana_library/components/Elements/Button";
import tabs_mixin from "@/components/statistics/stats/tabs/tabs_mixin";
import CmSelect from "@/components/library/Form/CmSelect.vue";
import { mapState } from "vuex";
import export_statistic_mixin from "@/components/statistics/export_statistic_mixin";
import Spinner from "@/manzana_library/components/Widgets/Spinner.vue";

export default {

  components: {
    ScaleNumberClicks,
    TablePart,
    Button,
    CmSelect,
    Spinner,
  },
  mixins: [tabs_mixin, export_statistic_mixin],
  props: {
    stateBtnClick: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedTemplate: {},
      adapteredTemplates: [],
      template: "",
      statsTableValue: null,
      selectedTableParams: null,
      tableParamsOptions: [
        {
          id: 0,
          label: "Кликов всего",
        },
        {
          id: 1,
          label: "% от всех кликов",
        },
        {
          id: 2,
          label: "Уникальные клики",
        },
      ],
      isTable: true,
      filteredValues: null,
      showTemplateSelect: false,
    };
  },

  mounted() {
    if (this.$route.query.type === "email") {
      const THIS = this;
      document
        .querySelector(".cm-page.mailout-statistics")
        .addEventListener("scroll", () => {
          // добавление класса
          if (document.querySelector(".click-map") &&
              document.querySelector(".click-map").getBoundingClientRect().top < 70) {
            // клик
            document.addEventListener("click", function (e) {
              try {
                if (document.querySelector(".click-map") &&
                    document.querySelector(".click-map").getBoundingClientRect().top < 70 &&
                    e.target.className) {
                  if (e.target.className === "cm-line-sidebar__btn" ||
                      e.target.className === "cm-line-sidebar__btn-icon" ||
                      e.target._prevClass === "icon icon--navbar" ||
                      e.target.parentElement._prevClass === "icon icon--navbar") {
                    THIS.addingClasses();
                  }
                }
              } catch (e) {
                console.error(e);
              }
            });

            // прокрутка
            THIS.addingClasses();
          }
          // удаление классов
          if (document.querySelector(".click-map") &&
              document.querySelector(".click-map").getBoundingClientRect().top > 69) {
            THIS.removingClasses();
          }
        });
    } else {
      document
        .querySelector(".cm-page.promotion-statistics")
        .addEventListener("scroll", () => {
          // добавление класса
          if (
            document.querySelector(".click-map") &&
            document.querySelector(".click-map").getBoundingClientRect().top < 70
          ) {
            // клик
            document.addEventListener("click", function (e) {
              try {
                if (document.querySelector(".click-map") &&
                    document.querySelector(".click-map").getBoundingClientRect().top < 70 &&
                    e.target.className) {
                  if (e.target._prevClass === "icon icon--navbar" ||
                      e.target._prevClass === "logo__navbar" ||
                      e.target.parentElement._prevClass === "logo" ||
                      e.target.parentElement._prevClass === "icon icon--navbar") {
                    if (document.getElementsByClassName("cm-layout--min").length === 0) {
                      document
                        .querySelector("#cm-table")
                        .classList.remove(
                          "scroll__stock-small",
                          "scroll__stock",
                        );
                      document
                        .querySelector("#cm-table")
                        .classList.add("scroll__stock-small");
                    }
                    if (document.getElementsByClassName("cm-layout--min").length === 1) {
                      document
                        .querySelector("#cm-table")
                        .classList.remove(
                          "scroll__stock-small",
                          "scroll__stock",
                        );
                      document
                        .querySelector("#cm-table")
                        .classList.add("scroll__stock");
                    }
                  }
                }
              } catch (e) {
                console.error(e);
              }
            });

            // прокрутка
            if (document.getElementsByClassName("cm-layout--min").length === 0) {
              document
                .querySelector("#cm-table")
                .classList.remove("scroll__stock-small", "scroll__stock");
              document
                .querySelector("#cm-table")
                .classList.add("scroll__stock-small");
            }
            if (document.getElementsByClassName("cm-layout--min").length === 1) {
              document
                .querySelector("#cm-table")
                .classList.remove("scroll__stock-small", "scroll__stock");
              document.querySelector("#cm-table").classList.add("scroll__stock");
            }
          }
          // удаление классов
          if (document.querySelector(".click-map") &&
              document.querySelector(".click-map").getBoundingClientRect().top > 69) {
            document
              .querySelector("#cm-table")
              .classList.remove("scroll__stock-small", "scroll__stock");
          }
        });
    }
  },

  created() {
    this.upload();
  },

  computed: {
    ...mapState({
      selectedPeriod: state => state.stat.statDateText,
      isLoading: state => state.stat.loadings.clickmap,
      isError: state => state.stat.errors.clickmap,
      clickmap: state => state.stat.data.clickmap,
    }),
  },

  watch: {
    selectedTableParams: {
      handler(val) {
        if (!val) return;
        [...document.getElementsByClassName("active_cliks")].forEach((item) => {
          item.classList.remove("active_cliks");
        });

        switch (val.id) {
        case 0:
          this.addActiveClass("show-clicks");
          break;
        case 1:
          this.addActiveClass("show-percent");
          break;
        case 2:
          this.addActiveClass("show-unique");
          break;
        }
      },
      deep: true,
    },

    // изминение периода времени
    clickmap() {
      this.clear();
      this.upload();
    },

    // изминение селекта с выбором шаблона
    selectedTemplate: {
      handler(val) {
        this.selectedTableParams = this.tableParamsOptions[0];
        this.clickmap.forEach((i) => {
          if (i.stepId === val.id) {
            this.template = i.template;
            this.statsTableValue = i.clicks;
          }
        });
      },
      deep: true,
      immediate: true,
    },

    // изминение таблицы
    statsTableValue() {
      this.showInfoInTemplate();
    },
  },

  methods: {
    clickClickmap(e) {
      try {
        if (
          e.target &&
            e.target.nextElementSibling &&
            e.target.nextElementSibling.className == "show-percent" &&
            e.target.nextElementSibling.nextSibling.parentElement.classList[0] === "btn_click--metateg"
        ) {
          if (this.isTable) {
            this.filteredValues = null;
            this.filteredValues = this.statsTableValue.filter((j) => {
              return new RegExp(
                `${e.target.parentNode.children[3].innerHTML}`,
                "gim",
              ).test(j.link);
            });
            this.isTable = false;
          } else {
            this.isTable = true;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    clear() {
      this.selectedTemplate = {};
      this.adapteredTemplates.length = 0;
      this.selectedTableParams = null;
      this.template = "";
      this.statsTableValue = null;
      this.isTable = true;
      this.filteredValues = null;
      this.showTemplateSelect = false;
    },

    buttonAlignment(e, div, pLink) {
      if ("TD" === e.parentNode.nodeName) {
        div.style.top =
          e.parentNode.getBoundingClientRect().height - 40 > 0
            ? `${(e.parentNode.getBoundingClientRect().height - 40) / 2}px`
            : `-${(40 - e.parentNode.getBoundingClientRect().height) / 2}px`;
        div.style.left = `${
          e.parentNode.getBoundingClientRect().width / 2 - 20
        }px`;

        div.onclick = () => {
          if (
            this.filteredValues &&
            this.filteredValues[0].link === pLink.innerText
          ) {
            this.isTable = this.isTable ? false : true;
          } else if (!this.filteredValues) {
            this.filteredValues = this.statsTableValue.filter(
              (element) => element.link === pLink.innerText,
            );
            this.isTable = false;
          } else if (this.filteredValues[0].link !== pLink.innerText) {
            this.filteredValues = this.statsTableValue.filter(
              (element) => element.link === pLink.innerText,
            );
            this.isTable = false;
          }
        };

        e.parentNode.style.position = "relative";
        e.after(div);
      } else {
        this.buttonAlignment(e.parentNode, div, pLink);
      }
    },

    async upload() {
      if (!(this.clickmap && this.clickmap.length)) return;
      if (this.$route.query.type === "email") {
        this.template = this.clickmap[0].template;
        this.statsTableValue = this.clickmap[0].clicks;
      } else {
        this.showTemplateSelect = true;
        this.clickmap.forEach((i) => {
          this.adapteredTemplates.push({
            id: i.stepId,
            label: `${i.mailOutName.length === 0 ? this.$t(`campaign.statistics.untitled`) : i.mailOutName} (${i.templateName.length === 0 ? this.$t(`campaign.statistics.untitled`) : i.templateName})`,
          });
        });

        this.selectedTemplate = this.adapteredTemplates[0];

        // вывод первого шаблона
        this.template = this.clickmap[0].template;

        // вывод первой таблицы
        this.statsTableValue = this.clickmap[0].clicks;
      }
    },

    showInfoInTemplate() {
      if (!this.statsTableValue) return;
      setTimeout(() => {
        let element = document.getElementsByClassName("btn_click"); // сброс кнопок если они были раньше
        while (element.length) {
          element[0].parentNode.removeChild(element[0]);
        }

        Array.from(document.querySelectorAll("a")).forEach((e) => {
          if (!/\[\%/.test(e.href)) {
            this.statsTableValue.forEach((i) => {
              const linkLeft = /(utm_clickmap=)(\d+)/.test(decodeURIComponent(e.href)) ? decodeURIComponent(e.href).match(/(utm_clickmap=)(\d+)/)[2] : null;
              const linkRight = /(utm_clickmap=)(\d+)/.test(i.url) ? i.url.match(/(utm_clickmap=)(\d+)/)[2] : null;
              if ((decodeURIComponent(e.href) === i.link || (linkLeft && linkLeft === linkRight)) && i.total > 0) {
                const div = document.createElement("div");
                div.className = "btn_click";

                this.setColor(div, i.percent);

                const divClicks = document.createElement("div");
                divClicks.className = "show-clicks active_cliks";
                divClicks.innerHTML = `${i.total}`;
                div.append(divClicks);

                const divPercent = document.createElement("div");
                divPercent.className = "show-percent";
                divPercent.innerHTML = `${i.percent} %`;
                div.append(divPercent);

                const divUnique = document.createElement("div");
                divUnique.className = "show-unique";
                divUnique.innerHTML = `${i.unique}`;
                div.append(divUnique);

                const pLink = document.createElement("p");
                pLink.innerHTML = `${i.link}`;
                pLink.style.display = "none";
                div.before(pLink);

                this.buttonAlignment(e, div, pLink);
              }
            });
          }
          this.changingCoordinatesForBtnClick();
        });
      }, 500);
    },

    // this method is needed for the correct drawing of buttons with the btn_click class inside the td
    // button layout changes only when there are more than two buttons in td
    changingCoordinatesForBtnClick() {
      Array.from(document.getElementsByClassName('btn_click')).forEach(i => {
        const arrBtnClickInParentNode = Array.from(i.parentNode.getElementsByClassName('btn_click'));

        if (arrBtnClickInParentNode.length > 1) {
          let heightPreviousElements = 0;
          arrBtnClickInParentNode.forEach(j => {
            heightPreviousElements += j.previousElementSibling.offsetHeight;
            j.style.top = (heightPreviousElements - (j.previousElementSibling.offsetHeight - 40) / 2) + "px";
          });
        }
      });
    },

    addActiveClass(e) {
      const elements = document.getElementsByClassName(e);
      [...elements].forEach((i) => i.classList.add("active_cliks"));
    },

    setColorMetavariables(fractionalNumber) {
      const integer = Math.floor(fractionalNumber);
      const colorClassIndexes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      const maximumValue = 100;
      const range = maximumValue/colorClassIndexes.length;
      return `color_${colorClassIndexes[Math.floor(integer/range)]}`;
    },

    setColor(div, i) {
      div.classList.add(this.setColorMetavariables(i));
    },

    removingClasses() {
      document
        .querySelector("#cm-table")
        .classList.remove(
          "scroll__template-small",
          "scroll__template-very-small",
          "scroll__template-big",
          "scroll__template-very-big",
        );
    },

    addingClasses() {
      if (document.getElementsByClassName("cm-line-sidebar--closed").length === 0 &&
          document.getElementsByClassName("cm-layout--min").length === 0) {
        this.removingClasses();
        document
          .querySelector("#cm-table")
          .classList.add("scroll__template-very-small");
      }
      if (document.getElementsByClassName("cm-line-sidebar--closed").length === 1 &&
          document.getElementsByClassName("cm-layout--min").length === 0) {
        this.removingClasses();
        document
          .querySelector("#cm-table")
          .classList.add("scroll__template-small");
      }
      if (document.getElementsByClassName("cm-line-sidebar--closed").length === 0 &&
          document.getElementsByClassName("cm-layout--min").length === 1) {
        this.removingClasses();
        document
          .querySelector("#cm-table")
          .classList.add("scroll__template-big");
      }
      if (document.getElementsByClassName("cm-line-sidebar--closed").length === 1 &&
          document.getElementsByClassName("cm-layout--min").length === 1) {
        this.removingClasses();
        document
          .querySelector("#cm-table")
          .classList.add("scroll__template-very-big");
      }
    },
  },
};
</script>

<style lang="scss">
.tabs-header__title-container {
  max-width: 100%;
  display: flex;
  justify-content: space-between;

  .cm-title {
    margin: 25px 0 25px 0;
  }

  .custom-button-select {
    display: inline-block;
    position: relative;
    //top: 16px;
  }
}
.spinner.spinner_small_clickMap {
  position: absolute;
  top: 31px;
  left: 0;
}
.spinner_styles {
  margin-left: 25px;
}
.section-statistics__tab {
  width: 100%;
}

.stateBtnClickStyles {
  margin-top: 23px;
}

.click-map {
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;

  &__select {
    margin-bottom: 20px;

    .cm-select {
      width: 750px;

      &__choice {
        border: 1px solid #ddd;
        color: #373a3c;
        width: 750px;
      }

      &__options-container {
        border: 1px solid #ddd;
      }

      &__option {
        &:hover {
          color: $color_green;
          background: rgba(102, 204, 0, 0.15);
        }
      }
    }
  }

  &__template {
    width: 40%;
    min-width: 750px;
    overflow: hidden;
    border: 1px solid #dddddd;

    table td {
      padding: 0px;
    }
  }

  &__table {
    width: calc(60% - 35px);
    margin-left: 35px;
    height: calc(100vh - 100px);

    .statistics-group-table {
      width: 100%;

      .cm-stat-table-container.cm-stat-table-container--long {
        width: 100% !important;
      }
    }

    .button.button--primary {
      margin-top: 5px;
    }
  }

  .scroll {
    &__stock-small {
      position: fixed !important;
      top: 70px;
      margin-right: 30px;
      overflow: hidden;
      overflow-y: auto;
      left: 1056px;
      right: 30px;
      width: calc(100vw - 1120px) !important;
    }

    &__stock {
      position: fixed !important;
      top: 70px;
      margin-right: 30px;
      overflow: hidden;
      overflow-y: auto;
      left: 834px;
      right: 30px;
      width: calc(100vw - 900px) !important;
    }

    &__template-very-small {
      position: fixed !important;
      top: 70px;
      margin-right: 30px;
      overflow: hidden;
      overflow-y: auto;
      left: 1575px;
      right: 30px;
      width: calc(100vw - 1656px) !important;
    }

    &__template-small {
      position: fixed !important;
      top: 70px;
      margin-right: 30px;
      overflow: hidden;
      overflow-y: auto;
      left: 1126px;
      right: 30px;
      width: calc(100vw - 1207px) !important;
    }

    &__template-big {
      position: fixed !important;
      top: 70px;
      margin-right: 30px;
      overflow: hidden;
      overflow-y: auto;
      left: 1354px;
      right: 30px;
      width: calc(100vw - 1435px) !important;
    }

    &__template-very-big {
      position: fixed !important;
      top: 70px;
      margin-right: 30px;
      overflow: hidden;
      overflow-y: auto;
      left: 903px;
      right: 30px;
      width: calc(100vw - 984px) !important;
    }
  }
}

.color {
  transition: box-shadow 0.3s ease-in-out;

  &_1 {
    background: #b4eddc;
    &:hover {
      background: #a2d5c6;
      box-shadow: 0px 0px 30px 5px #a2d5c6;
    }
  }

  &_2 {
    background: #abef9c;
    &:hover {
      background: #9ad78c;
      box-shadow: 0px 0px 30px 5px #9ad78c;
    }
  }

  &_3 {
    background: #b4f275;
    &:hover {
      background: #a2da69;
      box-shadow: 0px 0px 30px 5px #a2da69;
    }
  }

  &_4 {
    background: #c5f553;
    &:hover {
      background: #b1dd4b;
      box-shadow: 0px 0px 30px 5px #b1dd4b;
    }
  }

  &_5 {
    background: #e5f25a;
    &:hover {
      background: #ceda51;
      box-shadow: 0px 0px 30px 5px #ceda51;
    }
  }

  &_6 {
    background: #ffe354;
    &:hover {
      background: #e6cc4c;
      box-shadow: 0px 0px 30px 5px #e6cc4c;
    }
  }

  &_7 {
    background: #f5b547;
    &:hover {
      background: #dda340;
      box-shadow: 0px 0px 30px 5px #dda340;
    }
  }

  &_8 {
    background: #f08c3e;
    &:hover {
      background: #d87e38;
      box-shadow: 0px 0px 30px 5px #d87e38;
    }
  }

  &_9 {
    background: #ee5c35;
    &:hover {
      background: #d65330;
      box-shadow: 0px 0px 30px 5px #d65330;
    }
  }

  &_10 {
    background: #e92527;
    &:hover {
      background: #d22123;
      box-shadow: 0px 0px 30px 5px #d22123;
    }
  }
}

.btn_click {
  font-family: "SF UI Display", sans-serif;
  font-size: 15px;
  font-weight: bold;
  display: block;
  min-width: 40px;
  height: 30px;
  border: 2px solid #ededed;
  border-radius: 15px;
  position: absolute;
  padding: 2px 8px 0px 8px;
  text-align: center;
  z-index: 1;
  color: #000;
  cursor: pointer;

  &--metateg {
    position: static;
    font-family: "SF UI Display", sans-serif;
    font-size: 15px;
    font-weight: bold;
    display: block;
    border: 2px solid #ededed;
    border-radius: 15px;
    padding: 0px 8px 0px 8px;
    text-align: center;
    color: #000;
    cursor: pointer;

    &:hover {
      color: #fff;
    }
  }

  &:hover {
    color: #fff;
  }
}

.show-clicks,
.show-percent,
.show-unique {
  display: none;
  white-space: nowrap;
}

.active_cliks {
  display: block;
}

.scroll__stock-small::-webkit-scrollbar,
.scroll__stock::-webkit-scrollbar,
.scroll__template-very-small::-webkit-scrollbar,
.scroll__template-small::-webkit-scrollbar,
.scroll__template-big::-webkit-scrollbar,
.scroll__template-very-big::-webkit-scrollbar {
  width: 8px;
}

.scroll__stock-small::-webkit-scrollbar-track,
.scroll__stock::-webkit-scrollbar-track,
.scroll__template-very-small::-webkit-scrollbar-track,
.scroll__template-small::-webkit-scrollbar-track,
.scroll__template-big::-webkit-scrollbar-track,
.scroll__template-very-big::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 4px;
}

.scroll__stock-small::-webkit-scrollbar-thumb,
.scroll__stock::-webkit-scrollbar-thumb,
.scroll__template-very-small::-webkit-scrollbar-thumb,
.scroll__template-small::-webkit-scrollbar-thumb,
.scroll__template-big::-webkit-scrollbar-thumb,
.scroll__template-very-big::-webkit-scrollbar-thumb {
  background: #aaa;
  border-radius: 10px;
}

.scroll__stock-small::-webkit-scrollbar-thumb:hover,
.scroll__stock::-webkit-scrollbar-thumb:hover,
.scroll__template-very-small::-webkit-scrollbar-thumb:hover,
.scroll__template-small::-webkit-scrollbar-thumb:hover,
.scroll__template-big::-webkit-scrollbar-thumb:hover,
.scroll__template-very-big::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}
</style>